import { Quote } from "lucide-react";
import ceo from "@/assets/ceo.jpg";

/* export function CEO() {
  return (
    <section className="relative section-y overflow-hidden bg-navy-deep text-white">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_30%,oklch(0.42_0.11_240/0.35),transparent_55%)]" />
      <div className="container-x relative grid gap-12 lg:grid-cols-12 lg:items-center">
        <div className="lg:col-span-4">
          <div className="relative mx-auto max-w-sm">
            <div className="absolute -inset-4 rounded-2xl border border-orange/40" />
            <img
              src={ceo}
              alt="CEO of Solid Proof Energy"
              width={896}
              height={1120}
              loading="lazy"
              className="relative aspect-[4/5] w-full rounded-2xl object-cover shadow-2xl"
            />
          </div>
        </div>
        <div className="lg:col-span-8">
          <span className="eyebrow">Message From The CEO</span>
          <Quote className="mt-6 h-12 w-12 text-orange/70" />
          <blockquote className="mt-4 text-2xl font-medium leading-snug text-white sm:text-3xl">
            "At Solid Proof Energy, our mission is clear: building trust through transparency. In industries where credibility defines success, we deliver rigorous inspection, auditing, verification, and engineering services that empower businesses and safeguard communities.
Our strength lies not only in technology and process, but in resilience. The marks of experience remind us that trust is earned through hard work, perseverance, and authenticity. This journey has shaped Solid Proof into more than a company — it is a partner committed to integrity, proof, and recognition of every client’s effort.
I am proud to lead a team that combines innovation with integrity, and passion with professionalism. Together, we are shaping a future where proof is not optional, but essential — a future defined by trust, accountability, and excellence.
Thank you for choosing Solid Proof Energy. We look forward to growing with you, hand in hand, through every challenge and every success."
          </blockquote>
          <div className="mt-8 flex items-center gap-4 border-t border-white/15 pt-6">
            <div>
              <div className="text-lg font-bold text-white">Mohammed Al-Rashed</div>
              <div className="text-sm uppercase tracking-widest text-orange">
                Founder & Chief Executive Officer
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
} */


export function CEO() {
  return (
    <section className="relative section-y overflow-hidden bg-navy-deep text-white">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(255,255,255,0.08),transparent_40%)]" />

      <div className="container-x relative">

        {/* Section Header */}
        <div className="mb-12 text-center">
         {/*  <span className="text-sm font-bold uppercase tracking-[0.35em] text-orange">
            Leadership
          </span> */}

          <h2 className="mt-4 text-4xl font-black tracking-tight text-orange md:text-5xl">
            Message From The CEO
          </h2>

          <div className="mx-auto mt-6 h-1 w-24 rounded-full bg-orange" />
        </div>

        {/* Content Card */}
        <div className="mx-auto max-w-6xl rounded-3xl border border-white/10 bg-white/[0.03] p-8 backdrop-blur-sm lg:p-12">
          <div className="flex flex-col gap-10 lg:flex-row lg:items-start lg:justify-between">

            {/* CEO Info */}
            <div className="lg:w-72 shrink-0">
              <div className="text-2xl font-black text-white">
               Mohamed Ramzy
              </div>

              <div className="mt-2 text-sm uppercase tracking-[0.25em] text-orange">
                Co-Founder & Chief Executive Officer
              </div>

              <div className="mt-8 h-px bg-white/10" />

              <p className="mt-6 text-sm leading-7 text-white/70">
                Guiding Solid Proof Energy through a commitment to trust,
                innovation, and uncompromising professional standards.
              </p>
            </div>

            {/* CEO Message */}
            <div className="relative max-w-4xl">
              <Quote className="absolute -top-6 -left-4 h-24 w-24 text-white/5" />

              <div className="space-y-6 text-lg leading-9 text-white/90">

                <p>
                  At Solid Proof Energy, our mission is clear: building trust
                  through transparency. In industries where credibility defines
                  success, we deliver rigorous inspection, auditing,
                  verification, and engineering services that empower
                  businesses and safeguard communities.
                </p>

                <p>
                  Our strength lies not only in technology and process, but in
                  resilience. The marks of experience remind us that trust is
                  earned through hard work, perseverance, and authenticity.
                  This journey has shaped Solid Proof into more than a company
                  — it is a partner committed to integrity, proof, and
                  recognition of every client's effort.
                </p>

                <p>
                  I am proud to lead a team that combines innovation with
                  integrity, and passion with professionalism. Together, we are
                  shaping a future where proof is not optional, but essential —
                  a future defined by trust, accountability, and excellence.
                </p>

                <p className="font-medium text-white">
                  Thank you for choosing Solid Proof Energy. We look forward to
                  growing with you, hand in hand, through every challenge and
                  every success.
                </p>

              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

